<template>
	<section id="dashfilter">
		<DashFilter :mainfilters="mainfilters" @toggleMainFilter="toggleMainFilter" @toggleSubFilter="toggleSubFilter" />

		<template v-if="mainfilter_active.key === 'complaint'">
			<h2>Beschwerden ({{ filteredComplaints.length }} Ergebnisse)</h2>
			<ComplaintsTable
				:tableData="filteredComplaints"
				:loading="false"
				:totalCount="filteredComplaints.length"
				:isDummy="true"
				@loadNextPage="() => {}"
			/>
		</template>

		<template v-if="mainfilter_active.key === 'case'">
			<h2>Fälle ({{ filteredCases.length }} Ergebnisse)</h2>
			<CasesTable :tableData="filteredCases" :loading="false" :totalCount="filteredCases.length" :isDummy="true" @loadNextPage="() => {}" />
		</template>
	</section>
</template>

<script lang="ts">
import { defineComponent, provide } from 'vue';
import store, { key as storeKey } from '@/store';
import DashFilter, { FilterItem } from '@/components/DashFilter.vue';
import ComplaintsTable from '@/components/tables/ComplaintsTable.vue';
import CasesTable from '@/components/tables/CasesTable.vue';
import { CaseFilters, CaseResponse, CaseState, ComplaintFilters, ComplaintResponse, ComplaintState, Gender, StatementState } from '@/types/types';

const CATEGORY_WERBUNG = { id: 'cat-01', name: 'Irreführende Werbung', number: '1.1' };
const CATEGORY_SEXISMUS = { id: 'cat-02', name: 'Sexistische Werbung', number: '1.2' };
const CATEGORY_KINDER = { id: 'cat-03', name: 'Werbung für Kinder', number: '1.3' };
const CATEGORY_VERGLEICH = { id: 'cat-04', name: 'Vergleichende Werbung', number: '2.1' };

const MEDIUM_TV = { id: 'med-01', name: 'TV' };
const MEDIUM_PRINT = { id: 'med-02', name: 'Print' };
const MEDIUM_ONLINE = { id: 'med-03', name: 'Online' };
const MEDIUM_OOH = { id: 'med-04', name: 'Out-of-Home' };

const allComplaints: ComplaintResponse[] = [
	{
		id: 'c001',
		hid: 'B-2024-001',
		title: 'Irreführende Preisangabe in TV-Spot',
		state: ComplaintState.NotAssigned,
		category: CATEGORY_WERBUNG,
		medium: MEDIUM_TV,
		createdDate: '2024-03-10T09:15:00Z',
		updatedDate: '2024-03-10T09:15:00Z',
		text: 'Der Werbespot zeigt einen Preis, der im Geschäft nicht erhältlich ist.',
		callbacks: [],
		links: [],
		files: [],
		publishedDate: null,
		confirmedDate: null,
		decidedDate: null,
		firstName: 'Maria',
		lastName: 'Müller',
		gender: Gender.Female,
		email: 'maria.mueller@example.at',
		phone: '+43 699 1234567',
		company: null,
		internalNote: null,
	},
	{
		id: 'c002',
		hid: 'B-2024-002',
		title: 'Sexistische Darstellung in Printanzeige',
		state: ComplaintState.NotAssigned,
		category: CATEGORY_SEXISMUS,
		medium: MEDIUM_PRINT,
		createdDate: '2024-03-12T11:30:00Z',
		updatedDate: '2024-03-12T11:30:00Z',
		text: 'Die Anzeige zeigt Frauen in entwürdigender Weise.',
		callbacks: [],
		links: [],
		files: [],
		publishedDate: null,
		confirmedDate: null,
		decidedDate: null,
		firstName: 'Thomas',
		lastName: 'Berger',
		gender: Gender.Male,
		email: 'thomas.berger@example.at',
		phone: '+43 699 2345678',
		company: null,
		internalNote: null,
	},
	{
		id: 'c003',
		hid: 'B-2024-003',
		title: 'Irreführende Gesundheitsaussagen bei Nahrungsergänzungsmitteln',
		state: ComplaintState.NotAssigned,
		category: CATEGORY_WERBUNG,
		medium: MEDIUM_ONLINE,
		createdDate: '2024-03-15T14:00:00Z',
		updatedDate: '2024-03-15T14:00:00Z',
		text: 'Das Produkt verspricht medizinische Wirkungen ohne wissenschaftlichen Beleg.',
		callbacks: [],
		links: [],
		files: [],
		publishedDate: null,
		confirmedDate: null,
		decidedDate: null,
		firstName: 'Sabine',
		lastName: 'Hofer',
		gender: Gender.Female,
		email: 'sabine.hofer@example.at',
		phone: '+43 699 3456789',
		company: null,
		internalNote: null,
	},
	{
		id: 'c004',
		hid: 'B-2024-004',
		title: 'Werbung mit Kindern in ungeeignetem Kontext',
		state: ComplaintState.Assigned,
		category: CATEGORY_KINDER,
		medium: MEDIUM_TV,
		createdDate: '2024-02-20T08:00:00Z',
		updatedDate: '2024-03-01T10:00:00Z',
		text: 'Kinder werden in dieser Werbung für Erwachsenenprodukte eingesetzt.',
		callbacks: [],
		links: [],
		files: [],
		publishedDate: null,
		confirmedDate: '2024-03-01T10:00:00Z',
		decidedDate: null,
		firstName: 'Klaus',
		lastName: 'Wagner',
		gender: Gender.Male,
		email: 'klaus.wagner@example.at',
		phone: '+43 699 4567890',
		company: null,
		internalNote: null,
	},
	{
		id: 'c005',
		hid: 'B-2024-005',
		title: 'Vergleichende Werbung ohne sachlichen Bezug',
		state: ComplaintState.Assigned,
		category: CATEGORY_VERGLEICH,
		medium: MEDIUM_ONLINE,
		createdDate: '2024-02-25T13:45:00Z',
		updatedDate: '2024-03-05T09:30:00Z',
		text: 'Der Mitbewerber wird ohne nachvollziehbare Grundlage schlechtgemacht.',
		callbacks: [],
		links: [],
		files: [],
		publishedDate: null,
		confirmedDate: '2024-03-05T09:30:00Z',
		decidedDate: null,
		firstName: 'Andrea',
		lastName: 'Schneider',
		gender: Gender.Female,
		email: 'andrea.schneider@example.at',
		phone: '+43 699 5678901',
		company: 'Muster GmbH',
		internalNote: null,
	},
];

const minimalComplaint = (id: string, hid: string): ComplaintResponse => ({
	id,
	hid,
	title: '',
	state: ComplaintState.Assigned,
	category: CATEGORY_WERBUNG,
	medium: MEDIUM_TV,
	text: '',
	callbacks: [],
	links: [],
	files: [],
	publishedDate: null,
	confirmedDate: null,
	decidedDate: null,
	firstName: '',
	lastName: '',
	gender: Gender.Diverse,
	email: '',
	phone: '',
	company: null,
	internalNote: null,
});

const allCases: CaseResponse[] = [
	{
		id: 'f001',
		hid: 'F-2024-001',
		title: 'Irreführende Werbung – Elektronikmarkt Prospekt',
		state: CaseState.Statements,
		category: CATEGORY_WERBUNG,
		mediums: [MEDIUM_PRINT, MEDIUM_ONLINE],
		createdDate: '2024-02-01T09:00:00Z',
		updatedDate: '2024-03-10T10:00:00Z',
		complaints: [minimalComplaint('cx01', 'B-2024-011'), minimalComplaint('cx02', 'B-2024-012')],
		sectors: [],
		reaches: [],
		decisions: [],
		publishedDate: null,
		decidedDate: null,
		statementsDate: '2024-03-01T00:00:00Z',
		statements: [
			{
				id: 'st01',
				hid: 'S-2024-001',
				title: 'Stellungnahme Elektronikmarkt',
				createdDate: '2024-03-01T09:00:00Z',
				answer: 'Wir nehmen die Beschwerde zur Kenntnis...',
				answeredDate: '2024-03-15T14:00:00Z',
				files: [],
				links: [],
				internalNote: null,
				state: StatementState.Received,
				contact: { id: 'u01', email: 'kontakt@firma.at' } as any,
				firstValidDate: '2024-03-01T00:00:00Z',
				lastValidDate: '2024-03-20T00:00:00Z',
				case: null as any,
			},
			{
				id: 'st02',
				hid: 'S-2024-002',
				title: 'Stellungnahme Verband',
				createdDate: '2024-03-01T09:00:00Z',
				answer: null,
				answeredDate: null,
				files: [],
				links: [],
				internalNote: null,
				state: StatementState.NotReceived,
				contact: { id: 'u02', email: 'verband@example.at' } as any,
				firstValidDate: '2024-03-01T00:00:00Z',
				lastValidDate: '2024-03-25T00:00:00Z',
				case: null as any,
			},
		],
		voteEndDate: null,
		files: [],
		links: [],
	},
	{
		id: 'f002',
		hid: 'F-2024-002',
		title: 'Sexistische Darstellung – Modekampagne',
		state: CaseState.Statements,
		category: CATEGORY_SEXISMUS,
		mediums: [MEDIUM_OOH, MEDIUM_PRINT],
		createdDate: '2024-02-05T11:00:00Z',
		updatedDate: '2024-03-12T09:00:00Z',
		complaints: [minimalComplaint('cx03', 'B-2024-013'), minimalComplaint('cx04', 'B-2024-014'), minimalComplaint('cx05', 'B-2024-015')],
		sectors: [],
		reaches: [],
		decisions: [],
		publishedDate: null,
		decidedDate: null,
		statementsDate: '2024-03-05T00:00:00Z',
		statements: [
			{
				id: 'st03',
				hid: 'S-2024-003',
				title: 'Stellungnahme Modemarke',
				createdDate: '2024-03-05T09:00:00Z',
				answer: null,
				answeredDate: null,
				files: [],
				links: [],
				internalNote: null,
				state: StatementState.NotReceived,
				contact: { id: 'u03', email: 'mode@firma.at' } as any,
				firstValidDate: '2024-03-05T00:00:00Z',
				lastValidDate: '2024-03-30T00:00:00Z',
				case: null as any,
			},
		],
		voteEndDate: null,
		files: [],
		links: [],
	},
	{
		id: 'f003',
		hid: 'F-2024-003',
		title: 'Irreführende Gesundheitsversprechen – Nahrungsergänzung',
		state: CaseState.Statements,
		category: CATEGORY_WERBUNG,
		mediums: [MEDIUM_TV, MEDIUM_ONLINE],
		createdDate: '2024-02-10T14:00:00Z',
		updatedDate: '2024-03-08T11:00:00Z',
		complaints: [minimalComplaint('cx06', 'B-2024-016')],
		sectors: [],
		reaches: [],
		decisions: [],
		publishedDate: null,
		decidedDate: null,
		statementsDate: null,
		statements: [],
		voteEndDate: null,
		files: [],
		links: [],
	},
	{
		id: 'f004',
		hid: 'F-2024-004',
		title: 'Alkoholwerbung vor Schulen – Plakatstellen',
		state: CaseState.Statements,
		category: CATEGORY_KINDER,
		mediums: [MEDIUM_OOH],
		createdDate: '2024-02-12T09:30:00Z',
		updatedDate: '2024-03-05T10:00:00Z',
		complaints: [minimalComplaint('cx07', 'B-2024-017'), minimalComplaint('cx08', 'B-2024-018')],
		sectors: [],
		reaches: [],
		decisions: [],
		publishedDate: null,
		decidedDate: null,
		statementsDate: null,
		statements: [],
		voteEndDate: null,
		files: [],
		links: [],
	},
	{
		id: 'f005',
		hid: 'F-2024-005',
		title: 'Greenwashing – Automobilhersteller Kampagne',
		state: CaseState.ExaminationSmallSenate,
		category: CATEGORY_WERBUNG,
		mediums: [MEDIUM_TV, MEDIUM_PRINT, MEDIUM_ONLINE],
		createdDate: '2024-01-20T10:00:00Z',
		updatedDate: '2024-02-28T15:00:00Z',
		complaints: [minimalComplaint('cx09', 'B-2024-019'), minimalComplaint('cx10', 'B-2024-020')],
		sectors: [],
		reaches: [],
		decisions: [],
		publishedDate: null,
		decidedDate: null,
		statementsDate: null,
		statements: [],
		voteEndDate: null,
		files: [],
		links: [],
	},
];

export default defineComponent({
	name: 'OewrDashboardShowcase',
	setup() {
		provide(storeKey, store);
	},
	components: {
		DashFilter,
		ComplaintsTable,
		CasesTable,
	},
	data() {
		return {
			allComplaints,
			allCases,
			mainfilters: [
				{
					key: 'complaint',
					label: 'Beschwerden',
					active: true,
					subfilters: [
						{ key: ComplaintFilters.NotAssigned, label: 'nicht zugewiesen', active: false, count: 3 },
						{ key: ComplaintFilters.Assigned, label: 'zugewiesen', active: false, count: 2 },
						{ key: ComplaintFilters.UnansweredCallbacks, label: 'mit offener Rückfrage', active: false, count: 0 },
					],
				},
				{
					key: 'case',
					label: 'Fälle',
					active: false,
					subfilters: [
						{ key: CaseFilters.Statements, label: 'Stellungnahme angefordert', active: false, count: 4 },
						{ key: CaseFilters.ExaminationSmallSenate, label: 'im kleinen Senat', active: false, count: 1 },
						{ key: CaseFilters.ExaminationWerberat, label: 'im Werberat', active: false, count: 0 },
						{ key: CaseFilters.DecisionNoReason, label: 'Entscheidung: Kein Grund', active: false, count: 0 },
					],
				},
			] as FilterItem[],
		};
	},
	computed: {
		mainfilter_active(): FilterItem {
			return this.mainfilters.find((m) => m.active) || this.mainfilters[0];
		},
		activeSubfilterKeys(): string[] {
			return this.mainfilter_active.subfilters.filter((s) => s.active).map((s) => s.key);
		},
		filteredComplaints(): ComplaintResponse[] {
			if (this.activeSubfilterKeys.length === 0) return this.allComplaints;
			return this.allComplaints.filter((c) => this.activeSubfilterKeys.includes(c.state as string));
		},
		filteredCases(): CaseResponse[] {
			if (this.activeSubfilterKeys.length === 0) return this.allCases;
			return this.allCases.filter((c) => {
				return this.activeSubfilterKeys.some((key) => {
					if (key === CaseFilters.ExaminationSmallSenate) {
						return c.state === CaseState.ExaminationSmallSenate || c.state === CaseState.ExaminationSmallSenateRunning;
					}
					if (key === CaseFilters.ExaminationWerberat) {
						return c.state === CaseState.ExaminationWerberat || c.state === CaseState.ExaminationWerberatRunning;
					}
					return c.state === key;
				});
			});
		},
	},
	methods: {
		toggleMainFilter(filter: string) {
			this.mainfilters = this.mainfilters.map((m) => ({
				...m,
				active: m.key === filter,
				subfilters: m.subfilters.map((s) => ({ ...s, active: false })),
			}));
		},
		toggleSubFilter(filter: string) {
			const sub = this.mainfilter_active.subfilters.find((s) => s.key === filter);
			if (sub) sub.active = !sub.active;
		},
	},
});
</script>

<style lang="scss"></style>
